import { Grid, Typography, Box, CircularProgress, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import MainCard from '../../../component/cards/MainCard';
import { EditButton } from '../../../component/buttons';
import PlanosCard from './PlanosCard';
import { usePlansTemplates } from '../../../hooks/usePlansTemplates';

function DashboardPlanos() {
    const navigate = useNavigate();

    const {
        data: plans,
        isLoading,
        error,
        count,
        paginationModel,
        setPaginationModel
    } = usePlansTemplates();

    const handlePageChange = (event, newPage) => {
        setPaginationModel((prev) => ({
            ...prev,
            page: newPage - 1
        }));
    };

    return (
        <MainCard title={t('plans.title')}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Grid container justifyContent="flex-end" spacing={2}>
                        <Grid item>
                            <EditButton onClick={() => navigate('/planos/criar')}>
                                <Typography variant="subtitle2">
                                    {t('plans.addNew')}
                                </Typography>
                            </EditButton>
                        </Grid>
                    </Grid>
                </Grid>

                {isLoading ? (
                    <Grid item xs={12}>
                        <Box display="flex" justifyContent="center" p={4}>
                            <CircularProgress />
                        </Box>
                    </Grid>
                ) : error ? (
                    <Grid item xs={12}>
                        <Typography color="error" align="center">
                            {t('plans.load_error')}
                        </Typography>
                    </Grid>
                ) : plans.length === 0 ? (
                    <Grid item xs={12}>
                        <Typography align="center">
                            {t('plans.none_available')}
                        </Typography>
                    </Grid>
                ) : (
                    <>
                        {plans.map((plan) => (
                            <Grid key={plan.uuid} item lg={4} md={6} sm={6} xs={12}>
                                <PlanosCard
                                    planName={plan.name}
                                    planDesc={plan.description}
                                    pacientType={`${t('plans.created')} ${new Date(
                                        plan.created
                                    ).toLocaleDateString()}`}
                                    onClick={() => navigate(`/planos/${plan.uuid}`)}
                                />
                            </Grid>
                        ))}

                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="center" mt={4}>
                                <Pagination
                                    count={Math.ceil(count / paginationModel.pageSize)}
                                    page={paginationModel.page + 1}
                                    onChange={handlePageChange}
                                />
                            </Box>
                        </Grid>
                    </>
                )}
            </Grid>
        </MainCard>
    );
}

export default DashboardPlanos;